define(
    'modals/secured/explorer/navigation/folders/PurgeFolderModal',[
        "plugins/dialog",
        "i19n!i19n/strings"
    ],
    function (dialog, i19n) {

        function Modal() {
            var self = this;

            self.i19n = i19n;
            self.message = ko.observable(0);
        }

        Modal.prototype = {
            activate: function(count) {
                var self = this;
                var s = i19n.to.cannotdeletefolderbecauseitcontainsdeleted;

                self.message(s);
            },
            purge : function () {
                var self = this;

                dialog.close(self, { purge: true });
            },
            cancel : function () {
                var self = this;

                dialog.close(self, { cancel: true }); 
            }
        };

        return Modal;
    }
);
